import SocialPosts from '../views/socialposts/Index.vue';
import { checkauth } from '../Helper';

const SocialPostCreate = () => import('../views/socialposts/Create.vue');
const SocialPostEdit = () => import('../views/socialposts/Edit.vue');
const SocialTemplateCreate = () => import('../views/socialposts/TemplateCreate.vue');
const SocialTemplateEdit = () => import('../views/socialposts/TemplateEdit.vue');

const guard = (to, from, next) => {
	checkauth().then(response => (response ? next() : next('/login')));
};

export default [
	{ path: '/social-posts', name: 'social-posts', component: SocialPosts, beforeEnter: guard },
	{ path: '/social-posts/new', name: 'social-posts-new', component: SocialPostCreate, beforeEnter: guard },
	{ path: '/social-posts/:id([0-9a-fA-F]{24})', name: 'social-posts-edit', component: SocialPostEdit, beforeEnter: guard },
	{ path: '/social-posts/templates/new', name: 'social-templates-new', component: SocialTemplateCreate, beforeEnter: guard },
	{ path: '/social-posts/templates/:id([0-9a-fA-F]{24})', name: 'social-templates-edit', component: SocialTemplateEdit, beforeEnter: guard },
];
